export class Utils {
    static usedGuids: { [key: string]: boolean } = {};

    static newGuid(): string {
        const guid = `xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx`.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0,
                v = c === `x` ? r : r & 0x3 | 0x8;

            return v.toString(16);
        });

        if (!Utils.usedGuids[guid]) {
            Utils.usedGuids[guid] = true;
            return guid;
        }
        return Utils.newGuid(); // Oops, try again! 1 in 2^122 chance of this ever being called
    }
}